export const endPoints = {
  MONETARY_PAYMENT_ID: (id: number | string) => {
    return `/v1/monetary/payment/${id}`;
  },
  GET_ACCOUNT_NUMBERS: '/v1/monetary/payment/account-numbers'
};
